import { render, staticRenderFns } from "./bidding_purchase_return_list.vue?vue&type=template&id=53a317bc&scoped=true"
import script from "./bidding_purchase_return_list.vue?vue&type=script&lang=js"
export * from "./bidding_purchase_return_list.vue?vue&type=script&lang=js"
import style0 from "./bidding_purchase_return_list.vue?vue&type=style&index=0&id=53a317bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a317bc",
  null
  
)

export default component.exports